export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

// 点击菜单时或者页面刷新时，清空存储的页面的搜素条件
export const clearTableSearchParams = () => {
  // key值是以search_params结尾的，都清空
  Object.keys(sessionStorage).forEach((key) => {
    if (key.endsWith('_search_params')) {
      sessionStorage.removeItem(key)
    }
  })
}
